export const MembershipType = {
	invite: 1,
	application: 2,
	member: 4
}